/* CLEAR (Shopify) — render workbook + PDF export only
   - Renders from window.CLEAR_DOC (loaded by clear-content.js)
   - PDF export uses openClearPdfWindow() (loaded by clear-pdf.js)
   - NO saving (lead capture happens only in the Assessments Gate)
*/

(function () {
  'use strict';

  function todayISO() {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }

  function $(sel) { return document.querySelector(sel); }

  function escapeText(str = '') {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;');
  }

  function renderDocIntoForm(container, doc) {
    container.innerHTML = '';

    if (!doc) {
      container.innerHTML = `
        <div class="notice">
          <div class="pill">Missing content</div>
          <p class="p">CLEAR content file did not load (<code>clear-content.js</code>).</p>
        </div>`;
      return;
    }

    const form = document.createElement('form');
    form.id = 'clearForm';
    form.className = 'doc';

    const byPart = Array.isArray(doc.parts) ? doc.parts : [];
    byPart.forEach((part, pIdx) => {
      const partWrap = document.createElement('section');
      partWrap.className = 'realm';

      const band = document.createElement('div');
      band.className = 'realm__band';
      band.innerHTML = `
        <h2 class="realm__title">${escapeText(part.title || `PART ${pIdx + 1}`)}</h2>
      `;
      partWrap.appendChild(band);

      const inner = document.createElement('div');
      inner.className = 'realm__inner';

      (part.sections || []).forEach((sec, sIdx) => {
        const secWrap = document.createElement('div');
        secWrap.className = 'q';

        const secTitle = sec.title || `Section ${sIdx + 1}`;
        const why = sec.why
          ? `<p class="q__hint"><strong>Why this matters:</strong> ${escapeText(sec.why)}</p>`
          : '';

        secWrap.innerHTML = `
          <p class="q__title">${escapeText(secTitle)}</p>
          ${why}
        `;

        // Reflection questions
        const refl = sec?.reflection?.questions || [];
        if (refl.length) {
          const block = document.createElement('div');
          block.className = 'box';
          block.style.marginTop = '10px';
          block.innerHTML = `<div class="pill">Reflection Questions</div>`;
          refl.forEach((qText, qIdx) => {
            const id = `p${pIdx + 1}_s${sIdx + 1}_r${qIdx + 1}`;
            const row = document.createElement('div');
            row.style.marginTop = '10px';
            row.innerHTML = `
              <p class="p" style="margin-bottom:6px;"><strong>${qIdx + 1}.</strong> ${escapeText(qText)}</p>
              <textarea class="textarea" id="${id}" name="${id}" placeholder="Write your response..."></textarea>
            `;
            block.appendChild(row);
          });
          secWrap.appendChild(block);
        }

        // Spiritual integration questions
        const si = sec?.reflection?.spiritual_integration || [];
        if (si.length) {
          const block = document.createElement('div');
          block.className = 'box';
          block.style.marginTop = '10px';
          block.innerHTML = `<div class="pill">Spiritual Integration</div>`;
          si.forEach((qText, qIdx) => {
            const id = `p${pIdx + 1}_s${sIdx + 1}_si${qIdx + 1}`;
            const row = document.createElement('div');
            row.style.marginTop = '10px';
            row.innerHTML = `
              <p class="p" style="margin-bottom:6px;"><strong>${qIdx + 1}.</strong> ${escapeText(qText)}</p>
              <textarea class="textarea" id="${id}" name="${id}" placeholder="Write your response..."></textarea>
            `;
            block.appendChild(row);
          });
          secWrap.appendChild(block);
        }

        // Optional content paragraphs (if your doc includes them)
        if (Array.isArray(sec.paragraphs) && sec.paragraphs.length) {
          const box = document.createElement('div');
          box.className = 'box';
          box.style.marginTop = '10px';
          sec.paragraphs.forEach((p) => {
            const pe = document.createElement('p');
            pe.className = 'p';
            pe.textContent = p;
            box.appendChild(pe);
          });
          secWrap.appendChild(box);
        }

        inner.appendChild(secWrap);
      });

      partWrap.appendChild(inner);
      form.appendChild(partWrap);
    });

    container.appendChild(form);
  }

  document.addEventListener('DOMContentLoaded', () => {
    // Gate enforce + prefill (if loaded)
    try {
      const gate = window.FortifyGate?.requireGate?.();
      window.FortifyGate?.prefillCommonFields?.(gate);
    } catch (e) {}

    // Default date
    const dateEl = $('#date');
    if (dateEl && !dateEl.value) dateEl.value = todayISO();

    // Render dynamic form content
    const host = $('#clearFormHost');
    if (host) renderDocIntoForm(host, window.CLEAR_DOC);

    // PDF export
    const btnPdf = $('#btnViewPdf');
    if (btnPdf) {
      btnPdf.addEventListener('click', (e) => {
        e.preventDefault();
        if (typeof window.openClearPdfWindow === 'function') {
          window.openClearPdfWindow();
        } else {
          alert('PDF export is not available (clear-pdf.js not loaded).');
        }
      });
    }
  });
})();